const GetEmployeeMaintenance = (thiss) => {
  let uri;
  if (thiss.currentUser.EmployeeId == 37) {
    uri = `/api/Employees/GetByCompany?companyID=${thiss.currentCompany}`;
  } else {
    uri = `/api/Employees/GetEmployeeByCriteriaSupervisor?employeeid=${thiss.currentUser.EmployeeId}`;
  }

  thiss.$http
    .get(uri)
    .then((resp) => {
      const employees =
        thiss.currentUser.EmployeeId == 37
          ? resp.data
          : [...resp.data.user, ...resp.data.okEmployee];

      employees.forEach((element) => {
        const employee = {
          EmployeeID: element.EmployeeID || element.Id,
          Name: element.FullName || element.Name,
          Image: element.imageUrl || "/static/images/avatar-2.jpg" // Usa imagen predeterminada si falta
        };
        thiss.employeesByDirection.push(employee);
        console.log("Image cargada:", employee.Image); // Log para verificar las imágenes
      });
    })
    .catch((err) => {
      if (err.message.includes("404")) {
        const h = thiss.$createElement;
        thiss.$message({
          type: "info",
          message: h("p", null, [
            h("span", null, "Empleado no "),
            h("i", { style: "color: teal" }, "encontrado")
          ])
        });
      } else {
        thiss.$alert(err.message, err.name, { type: "error" });
      }
    });
};

export default GetEmployeeMaintenance;
